export default __webpack_public_path__ + "static/media/etsy.7b66f4da.png";